module.exports = __webpack_public_path__ + "img/calendar.e517103a.svg";